module.exports = __webpack_public_path__ + "media/wrong.9ee53a8d.mp3";